import { Box } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import { LIGHTEST_BACKGROUND } from "@/css/constants";

export default function ContentContainer({
  children,
  background = LIGHTEST_BACKGROUND,
}) {
  return (
    <Container>
      <Box bg={background} py={["16px", "24px"]}>
        {children}
      </Box>
    </Container>
  );
}
